import normalizeUser from "./normalizeUser";
import getAuthHeaders from "./getAuthHeaders";
import getAuthFetch from "./getAuthFetch";

let authFetch;

export default {
  install: (Vue, { strategy, fetchOptions = {} }) => {
    Vue.prototype.$auth = new Vue({
      data() {
        return {
          user: null,
          error: "",
          canLogin: true
        };
      },

      computed: {
        mockedUsers() {
          return strategy.getMockedUsers().map(normalizeUser);
        },

        plainHeaders() {
          const headers = getAuthHeaders(null, this.user);

          return Array.from(headers.keys()).reduce((acc, key) => ({ ...acc, [key]: headers.get(key) }), {});
        }
      },

      methods: {
        /**
         * @param {Object} user
         */
        setUser(user) {
          this.user = normalizeUser(user);

          if (typeof fetchOptions.onUnauth === "function") {
            fetchOptions.onUnauth = fetchOptions.onUnauth.bind(this);
          }

          authFetch = getAuthFetch({
            user: this.user,
            onUnauth: this.logout,
            ...fetchOptions
          });
        },

        clearUser() {
          this.user = null;
          authFetch = null;
        },

        /**
         * @return {Promise}
         */
        init() {
          this.error = "";

          return strategy.getConnectedUser()
            .then(user => {
              if (user) {
                this.setUser(user);
              }
            })
            .catch(error => {
              this.clearUser();
              this.error = error.message;
              this.canLogin = false;
            });
        },

        /**
         * @param {String} email
         * @param {String} password
         *
         * @return {Promise}
         */
        login(email, password) {
          this.error = "";

          return strategy.login(email, password)
            .then(user => {
              this.setUser(user);
            })
            .catch(error => {
              this.error = error.message;
            });
        },

        /**
         * @param {String} message
         *
         * @return {Promise}
         */
        logout(message) {
          return strategy.logout()
            .then(() => {
              this.clearUser();
              this.error = message;
            });
        },

        /**
         * @param {Object} portfolio
         */
        setCurrentPortfolio(portfolio) {
          this.user.currentPortfolio = portfolio;
        },

        /**
         * @param {String} url
         * @param {Object} params
         *
         * @return {Promise}
         */
        fetch(url, params) {
          return authFetch(url, params);
        },

        /**
         * @return {Promise}
         */
        getApps() {
          return strategy.getApps();
        }
      }
    });
  }
};
